export class WindowService {
  public prefersColorSchemeMatch(colorScheme: string): boolean {
    return window.matchMedia(`(prefers-color-scheme: ${colorScheme}`).matches
  }

  public get origin(): string {
    return window.location.origin
  }

  public get pathname(): string {
    return window.location.pathname
  }

  public reload(url: string) {
    window.location.href = url
  }

  public replace(href: string) {
    window.location.replace(href)
  }

  public findQueryParameter(paramKey: string): string | null {
    const queryString = window.location.search
    const searchParams = new URLSearchParams(queryString)
    return searchParams.get(paramKey)
  }

  public getPathnameWithStrippedPathSegments(pathSegments: string[]): string {
    return pathSegments.reduce(
      (pathname, pathSegment) => pathname.replace(`/${pathSegment}`, ''),
      window.location.pathname,
    )
  }
}
